import * as base64url from '../runtime/base64url.js';
export var encode = base64url.encode;
export var decode = base64url.decode;